import { render, staticRenderFns } from "./ClientWorkingPoint.vue?vue&type=template&id=2b6eea50&scoped=true"
import script from "./ClientWorkingPoint.vue?vue&type=script&lang=js"
export * from "./ClientWorkingPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6eea50",
  null
  
)

export default component.exports